import { Button, Guide } from '@zenterprise-inc/ui';

interface ErrorHometaxCommonViewController {
  handleAsk: () => void;
  moveBackPage: () => void;
}

interface Props {
  viewController: ErrorHometaxCommonViewController;
}

const ErrorHometaxCommonView = ({ viewController }: Props) => {
  return (
    <div className="flex h-[calc(100vh-100px)] w-full flex-col justify-center">
      <Guide>
        <Guide.TextArea>
          <Guide.Title className={'break-all'}>홈택스 오류로 수집하지 못했어요.</Guide.Title>
          <Guide.Description>다른 기기에서 홈택스 로그인으로 자동 로그아웃됐거나 홈택스 이용자가 많은 경우에 오류가 발생해요.</Guide.Description>
        </Guide.TextArea>
        <Guide.ButtonArea>
          <Button.Box size="large" state="primary" onClick={viewController.moveBackPage}>
            다시 시도하기
          </Button.Box>
        </Guide.ButtonArea>
        <div className={'font-normal text-15 text-gray-600 whitespace-pre'}>{' 오후 7시 이후에 시도하면 더 원활한 진행 가능해요.'}</div>
        <div className="fixed bottom-0 mb-[48px] flex w-screen max-w-[520px] items-center justify-center">
          <span className="body-14 mr-[10px] text-gray-700">같은 문제가 반복되시나요?</span>
          <Button.Box state="secondary" size="small" onClick={viewController.handleAsk}>
            문의하기
          </Button.Box>
        </div>
      </Guide>
    </div>
  );
};

export default ErrorHometaxCommonView;
